/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../helpers';
import { getRoleName } from '../../../../app/Hooks/CustomHooks';

const HeaderUserMenu = ({ user }) => {

  return (

    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-5 fs-6 w-275px mt-3'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            {/* <img alt='Logo' src={toAbsoluteUrl('/media/avatars/150-2.jpg')} /> */}
            <i className="fi fi-rr-user" style={{"fontSize": "3rem"}}></i>
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {user.name}
            </div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {getRoleName()}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      {/* <div className='menu-item px-5 my-1'>
        <Link to='/crafted/account/settings' className='menu-link px-5'>
          Configuración del perfil
        </Link>
      </div> */}

      <div className='menu-item px-5'>
        <Link to='/logout' className='menu-link px-5'>
          <i className="fi fi-rr-exit fs-1 me-5"></i> Cerrar Sesión
        </Link>
      </div>
    </div>
  )
}

export { HeaderUserMenu }


